import { Localized } from '@fluent/react'
import { useCallback, useState } from 'react'
import { TabContext, TabList, TabPanel } from '@mui/lab'
import { MailLogs } from './MailLogs'
import { Tab } from '@mui/material'
import { SysMailFooters } from './sysFooters/SysMailFooters'
import { SysMailTemplates } from './sysTemplates/SysMailTemplates'
import { MailTemplates } from './MailTemplates'

type FormTabs = "templates" | "logs" | "sysTemplates" | "sysFooters"

export const SysMailSettings = () => {
    const [tab, setTab] = useState<FormTabs>("sysTemplates");
    const handleTabChange = useCallback((_, newTab) => {
        setTab(newTab)
    }, [])

    return (
        <>
            <TabContext value={tab}>
                <TabList onChange={handleTabChange}>
                    <Tab
                        key={0}
                        value={"sysTemplates"}
                        label={<Localized id="sys-mail-templates">_Szablony systemowe</Localized>} />
                    <Tab
                        key={1}
                        value={"sysFooters"}
                        label={<Localized id="sys-mail-footers">_Stopki systemowe</Localized>} />
                    <Tab
                        key={2}
                        value={"templates"}
                        label={<Localized id="mail-settings-templates">Szablony maili</Localized>} />
                    <Tab
                        key={3}
                        value={"logs"}
                        label={<Localized id="mail-settings-logs">Historia wysyłania</Localized>} />
                </TabList>
                <TabPanel value="templates">
                    <MailTemplates/>
                </TabPanel>
                <TabPanel value="logs">
                    <MailLogs/>
                </TabPanel>
                <TabPanel value="sysTemplates">
                    <SysMailTemplates/>
                </TabPanel>
                <TabPanel value="sysFooters">
                    <SysMailFooters/>
                </TabPanel>
            </TabContext>

        </>
    );
}
